module.exports = __webpack_public_path__ + "img/scan.3d92609b.svg";